import adminApi from '@/api/admin'

export const passwordValidator = {
  /**
   * 비밀번호 유효성 검사
   * @param {string} password - 검사할 비밀번호
   * @returns {Object} - {isValid: boolean, message: string}
   */
  validatePassword(password) {
    if (!password) {
      return {
        isValid: false,
        message: '비밀번호를 입력해 주세요'
      }
    }
    return {
      isValid: true,
      message: ''
    }
  },

  /**
   * 서버에서 비밀번호 확인
   * @param {Object} formData - 비밀번호 데이터
   * @param {Function} onSuccess - 성공 콜백
   * @param {Function} onError - 실패 콜백
   */
  checkPassword(formData, onSuccess, onError) {
    adminApi.checkPassword(formData, (validFlag) => {
      if (validFlag === 'Y') {
        onSuccess()
      } else {
        onError('비밀번호가 일치하지 않습니다')
      }
    }, () => {
      onError('비밀번호를 확인할 수 없습니다')
    })
  },

  /**
   * 새 비밀번호 유효성 검사 (길이 체크)
   * @param {string} password - 검사할 비밀번호
   * @returns {Object} - {isValid: boolean, message: string}
   */
  validateNewPassword(password) {
    if (!password) {
      return {
        isValid: false,
        message: '새 비밀번호를 입력해 주세요'
      }
    }
    if (password.length < 8 || password.length > 20) {
      return {
        isValid: false,
        message: '8~20자로 입력해 주세요'
      }
    }
    return {
      isValid: true,
      message: ''
    }
  },

  /**
   * 비밀번호 확인 일치 검사
   * @param {string} password - 원본 비밀번호
   * @param {string} confirmPassword - 확인 비밀번호
   * @returns {Object} - {isValid: boolean, message: string}
   */
  validatePasswordMatch(password, confirmPassword) {
    if (!confirmPassword) {
      return {
        isValid: false,
        message: '비밀번호를 다시 입력해 주세요'
      }
    }
    if (password !== confirmPassword) {
      return {
        isValid: false,
        message: '비밀번호가 일치하지 않습니다'
      }
    }
    return {
      isValid: true,
      message: ''
    }
  },

  /**
   * 폼 상태 업데이트
   * @param {Object} formStatus - 폼 상태 객체
   * @param {string} target - 대상 필드명
   * @param {boolean} err - 에러 여부
   * @param {string} errMsg - 에러 메시지
   */
  updateFormStatus(formStatus, target, err, errMsg = '') {
    if (formStatus[target]) {
      formStatus[target].err = err
      formStatus[target].err_msg = errMsg
    }
  },

  /**
   * 전체 폼 유효성 검사
   * @param {Object} formData - 폼 데이터
   * @param {Object} formStatus - 폼 상태
   * @param {string} target - 특정 필드만 검사할 경우
   * @returns {boolean} - 유효성 여부
   */
  validateForm(formData, formStatus, target = null) {
    let isValid = true

    if (!target || target === 'currentPassword') {
      const validation = this.validatePassword(formData.currentPassword)
      this.updateFormStatus(formStatus, 'currentPassword', !validation.isValid, validation.message)
      if (!validation.isValid) isValid = false
    }

    if (!target || target === 'newPassword') {
      const validation = this.validateNewPassword(formData.newPassword)
      this.updateFormStatus(formStatus, 'newPassword', !validation.isValid, validation.message)
      if (!validation.isValid) isValid = false
    }

    if (!target || target === 'newPasswordConfirm') {
      const validation = this.validatePasswordMatch(formData.newPassword, formData.newPasswordConfirm)
      this.updateFormStatus(formStatus, 'newPasswordConfirm', !validation.isValid, validation.message)
      if (!validation.isValid) isValid = false
    }

    return isValid
  }
}